import { useTheme, Box, Card, CardHeader, Typography } from '@mui/material';
import navBarSurePassLogo from '../assets/navBarSurePassLogo.svg';

interface LogoCardProps {
  children: React.ReactNode;
  subheader?: string;
  subHeaderComponent?: React.ElementType;
}

const LogoCard = ({
  children,
  subheader,
  subHeaderComponent = 'p',
}: LogoCardProps) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        boxShadow: 'none',
        width: '760px',
        maxWidth: '98%',
        borderRadius: Number(theme.shape.borderRadius) / 2,
        display: 'flex',
        flexDirection: 'column',
        marginTop: '2%'
      }}
    >
      <CardHeader
        sx={{
          backgroundColor: theme.palette.primary.dark,
          padding: 4,
          height: {
            sm: '10%',
            md: '15%',
            lg: '20%'
          }
        }}
        title={
          <Box
            component="img"
            src={navBarSurePassLogo}
            alt="SurePass logo"
            sx={{ width: '160px' }}
          />
        }
        subheader={subheader && (
          <Typography
            variant='l'
            component={subHeaderComponent}
            sx={{
              color: theme.palette.background.default,
              mt: '16px'
            }}
          >
            {subheader}
          </Typography>
        )}
      >

      </CardHeader>
      {children}
    </Card>
  );
};

export default LogoCard;
